const jqueryModule = require("../../../../_ui/responsive/common/js/jquery-3.2.1.min.js");

const jquery = jqueryModule && jqueryModule.default ? jqueryModule.default : jqueryModule;
window.jQuery = window.$ = jquery;
module.exports = jquery;
